module.exports = __webpack_public_path__ + "static/media/snoopybrokenclouds02.263bf249.gif";